import * as STD     from '@emersya/mpa-std-lib';
import EngineModule from '../../../EngineModule';
import {
	NS as StandingPartitionsHeadsNS
}                   from '../../../components/customers/standing/StandingPartitionsHeads/StandingPartitionsHeads';

export default () => new EngineModule.UIEngineModule({
	type :             'ui',
	id :               'standing-partitionsHeads',
	dependencies :     [
		'oms-basket',
		'viewer-planner',
		'viewer-planner-layout-editor',
		'viewer-planner-dimensionsEditor'
	],
	modulesBefore :    [
		'product-editor',
		'viewer-planner-layout-editor',
		'viewer-planner-dimensionsEditor',
		'viewer-planner-floor-editor',
		'viewer-planner-walls-editor',
		'standing-highSign'
	],
	modulesAfter :     [
		'standing-banner',
		'viewer-planner-furniture-editor'
	],
	allowedCustomers : [ /* Local MPA */'XUJG0A2TF5', /* Prod */'STAODAZNIS', 'sam1_12345' ],
	usableCondition :  {
		type : 'and',
		LHS :  {
			type :      'notequal',
			component : 'K.basket',
			property :  'TARGET.basket.currentProduct',
			value :     null
		},
		RHS :  {
			type :      'notequal',
			component : 'K.basket',
			property :  '[*]TARGET.basket.currentProduct.getPart(["layout"]).currentOption',
			value :     null
		}
	},
	displayCondition : {
		type : 'or',
		LHS :  {
			type : 'and',
			LHS :  {
				type : 'and',
				LHS : {
					type :      'notequal',
					component : 'K.basket',
					property :  'TARGET.basket.currentProduct',
					value :     null
				},
				RHS : {
					type : 'or',
					LHS : {
						type :      'equal',
						component : 'K.basket',
						property :  'TARGET.basket.currentProduct.id',
						value :     'business'
					},
					RHS : {
						type :      'equal',
						component : 'K.basket',
						property :  'TARGET.basket.currentProduct.id',
						value :     'siae'
					}
					
				}
			},
			RHS :  {
				type : 'or',
				LHS :  {
					type :      'equal',
					component : 'K.basket',
					property :  '[*]TARGET.basket.currentProduct.getPart(["layout"]).currentOption',
					value :     null
				},
				RHS :  {
					type : 'and',
					LHS :  {
						type :      'notequal',
						component : 'K.basket',
						property :  '[*]TARGET.basket.currentProduct.getPart(["layout"]).currentOption',
						value :     null
					},
					RHS :  {
						type :      'notequal',
						component : 'K.basket',
						property :  '[*]TARGET.basket.currentProduct.getPart(["layout"]).currentOption.id',
						value :     'shape-no-wall'
					}
				}
			}
		},
		RHS :  {
			type :      'equal',
			component : 'K.basket',
			property :  'TARGET.basket.currentProduct',
			value :     null
		}
	},
	generateComponentConfiguration() : StandingPartitionsHeadsNS.Configuration {
		if (!this.translations.text || !this.translations.textLeft || !this.translations.textRight) {
			throw STD.errors.user('');
		}
		return {
			text :                 this.translations.text,
			forceBackgroundColor : this.configuration.forceBackgroundColor ? this.configuration.forceBackgroundColor : null,
			textLeft :             this.translations.textLeft,
			textRight :            this.translations.textRight
		};
	},
	async initialize() {
	}
});
